import React from 'react';
import { Route } from 'react-router-dom';
import ActivityDetector from "react-activity-detector";
import { getCookies, removeCookies, setIsShowDialogConfirmRefresh } from "../utils/configuration";
type RouterComponentProps = {
    path: string;
    component: React.ComponentType<any>;
    layout: React.ComponentType<any>;
    props?: any | undefined | null;
    isSetActive?: boolean;
    title?: string;
};

const createRoute = ({
    path,
    component: Component,
    layout: Layout,
    props = {},
    isSetActive = true,
    title = "",
}: RouterComponentProps) => {

    const onIdle = () => {
        if (getCookies("isLockScreen") !== "true") {
            setIsShowDialogConfirmRefresh(true);
        }
    };

    const onActive = () => {
        if (getCookies("isShowDialog") === "false") {
            removeCookies("isShowDialog");
        }
    };
    return (
        <Route
            key={path}
            path={path}
            element={
                <>
                    {isSetActive && (
                        <ActivityDetector
                            activityEvents={[
                                "click",
                                "mousemove",
                                "keydown",
                                "DOMMouseScroll",
                                "mousewheel",
                                "mousedown",
                                "touchstart",
                                "touchmove",
                                "focus",
                            ]}
                            enabled={true}
                            timeout={10 * 60 * 1000}
                            onIdle={onIdle}
                            onActive={onActive}
                        />
                    )}
                    <Layout pageTitle={title}>
                        <Component {...props} />
                    </Layout>
                </>
            }
        />
    )
};

export default createRoute;
